module.exports = __webpack_public_path__ + "img/trip_07.b7cfc97c.jpg";